import { render, staticRenderFns } from "./DefaultTable.vue?vue&type=template&id=dc63e678&scoped=true"
import script from "./DefaultTable.vue?vue&type=script&lang=js"
export * from "./DefaultTable.vue?vue&type=script&lang=js"
import style0 from "./DefaultTable.vue?vue&type=style&index=0&id=dc63e678&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc63e678",
  null
  
)

export default component.exports